import PropTypes from 'prop-types';
import { useTranslation } from '@eti/providers';
import { css, mediaQueries } from '@eti/styles';

const stopsTitleStyles = css`
  font-size: 0.625rem;
  margin-top: 3px;
  white-space: nowrap;

  @media ${mediaQueries.large.up} {
    font-size: 0.75rem;
  }
`;

const Stops = ({ stops }) => {
  const { t } = useTranslation();
  const stopText =
    stops === 1 ? t('TripDetails.Details.Stop') : t('TripDetails.Details.Stops', stops);

  if (!stops) {
    return null;
  }

  return (
    <p className={stopsTitleStyles} data-testid="searchResults-segment-stops">
      {stopText}
    </p>
  );
};

Stops.propTypes = {
  stops: PropTypes.number,
};

export default Stops;
